import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'full_period', label: 'Period', sortable: true },
    { key: 'work_type', label: 'Work type', sortable: true },
    { key: 'file', sortable: true },
    { key: 'actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('monitoring'),
  }
}
